"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationsProvider = exports.ApiContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _SfraApiClient = _interopRequireDefault(require("../services/SfraApiClient"));
var _SfScApiClient = _interopRequireDefault(require("../services/SfScApiClient"));
const ApiContext = exports.ApiContext = /*#__PURE__*/_react.default.createContext({});
const IntegrationsProvider = props => {
  const {
    children,
    config
  } = props;
  const sfraApiClient = new _SfraApiClient.default(config.sfraApiConfig);
  const sfscApiClient = new _SfScApiClient.default(config.sfscApiConfig);
  const services = {
    pages: sfraApiClient.Pages,
    giftCertificates: sfraApiClient.GiftCertificates,
    webToCase: sfscApiClient.WebToCase
  };
  return /*#__PURE__*/_react.default.createElement(ApiContext.Provider, {
    value: services
  }, children);
};
exports.IntegrationsProvider = IntegrationsProvider;